<div class="search-wrapper">
    <input type="text" class="search-input" pInputText [(ngModel)]="value"
        [placeholder]="placeholder" (keydown.enter)="onSearchClick()" />
    <i class="pi pi-search search-icon" (click)="onSearchClick()"></i>
</div>